import React from "react";
import CrudEditor from "./admin/CrudEditor";

export default function AdminTeam() {
  return (
    <CrudEditor
      title="Team"
      subtitle="Manage founder and team member profiles."
      endpoint="/team"
      testKey="team"
      emptyItem={{ name: "", role: "", bio: "", photo_url: "", linkedin: "", email: "", is_founder: false, order: 0 }}
      fields={[
        { key: "name", label: "Full name", type: "text" },
        { key: "role", label: "Role / Title", type: "text" },
        { key: "bio", label: "Bio", type: "textarea" },
        { key: "photo_url", label: "Photo URL", type: "text" },
        { key: "linkedin", label: "LinkedIn URL", type: "text" },
        { key: "email", label: "Email", type: "text" },
        { key: "is_founder", label: "Founder", type: "bool" },
        { key: "order", label: "Display order", type: "number" },
      ]}
    />
  );
}
